import React from 'react';
import { IconStyle } from 'styles/intro/common';

import { ReactComponent as LogoBlue } from 'assets/intro/logo_blue.svg';
import { ReactComponent as LogoGray } from 'assets/intro/logo_gray.svg';
import { ReactComponent as LogoWhite } from 'assets/intro/logo_white.svg';
import { ReactComponent as Line } from 'assets/intro/line.svg';

export function Icon({ name, children, ...props }) {
  return (
    <IconStyle {...props}>
      {name === 'logoBlue' && <LogoBlue />}
      {name === 'logoGray' && <LogoGray />}
      {name === 'logoWhite' && <LogoWhite />}
      {name === 'line' && <Line />}
      {children}
    </IconStyle>
  );
}
